import React from "react";
import Container from "../../components/Container";

const About = () => {
  return (
    <div className="about">
      <Container className="container py-4">
        <h5 className="text-center"> I am About Component !</h5>
      </Container>
    </div>
  );
};

export default About;
